import {Component} from "@angular/core";

@Component({
    selector: "wbo-page-navs",
    template: "<ng-content></ng-content>",
    styleUrls: ["./page-navs.component.scss"]
})
export class PageNavsComponent {
}
